import React from 'react';
import { useSelector } from 'react-redux';
import Lottie from 'react-lottie-player';

import lottieJson from './logo-animation.json';

export default function Loader() {
  const { isLoading, loadingText } = useSelector((state) => state.loading);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="loader_wrapper">
      <div className="loader">
        <Lottie
          loop
          animationData={lottieJson}
          play
          style={{ width: 100, height: 100, margin: 'auto', marginBottom: '1rem' }}
        />
        {loadingText}
      </div>
    </div>
  );
}
